<template>
	<div>
		<div class="common-form">添加技师</div>
		<el-form ref="form" :model="form" label-width="80px">
		  <el-form-item label="真实姓名">
		    <el-input class="max-w460" v-model="form.username"></el-input>
		  </el-form-item>
		<el-form-item label="性别">
		   <el-radio-group v-model="form.gender">
		     <el-radio label="男性"></el-radio>
		     <el-radio label="女性"></el-radio>
		   </el-radio-group>
		</el-form-item>
		 <el-form-item label="生日">
		   <el-input class="max-w460" v-model="form.birthday"></el-input>
		 </el-form-item>
		 <el-form-item label="身高">
		   <el-input class="max-w460" v-model="form.height"></el-input>
		 </el-form-item>
		 <el-form-item label="介绍">
		   <el-input class="max-w460" v-model="form.introduce"></el-input>
		 </el-form-item>
		 <el-form-item label="昵称">
		   <el-input class="max-w460" v-model="form.nickName"></el-input>
		 </el-form-item>
		 <el-form-item label="电话">
		   <el-input class="max-w460" v-model="form.mobile"></el-input>
		 </el-form-item>
		 <el-form-item label="工作时长">
		   <el-input class="max-w460" v-model="form.working_hours"></el-input>
		 </el-form-item>
		 <el-form-item label="经度">
		   <el-input class="max-w460" v-model="form.lng"></el-input>
		 </el-form-item>
		 <el-form-item label="纬度">
		   <el-input class="max-w460" v-model="form.lat"></el-input>
		 </el-form-item>
		 
		  <el-form-item>
		    <el-button type="primary" @click="onSubmit">立即添加</el-button>
		    <!-- <el-button>取消</el-button> -->
		  </el-form-item>
		</el-form>
		
	</div>
</template>

<script>
	import PorductApi from '@/api/product.js';
	export default {
		components: {},
		data(){
			return {
				form:{
					username:'',
					gender:'',
					// 生日
					birthday:'',
					// 身高
					height:'',
					// 介绍
					introduce:'',
					// 昵称
					nickName:'',
					// 电话
					mobile:'',
					// 工作时长
					working_hours:'',
					// 经度
					lng:'',
					// 纬度
					lat:'',
				}
			}
		},
		created() {
			// this.getData()
		},
		methods:{
			onSubmit() {
			  let self = this;
			  let username = self.form.username
			   let gender = self.form.gender
			    let birthday = self.form.birthday
				
				 let height = self.form.height
				  let introduce = self.form.introduce
				  
				   let nickName = self.form.nickName
				    let mobile = self.form.mobile
					 let working_hours = self.form.working_hours
					  let lng = self.form.lng
					  let lat = self.form.lat
					  
			  
			  self.$refs.form.validate(valid => {
			    if (valid) {
					PorductApi.addWaiter({
					    username,gender,birthday,height,introduce,nickName,mobile,working_hours,working_hours,lng,lat
					  }, true)
					  .then(data => {
					    self.$message({
					      message: '添加成功',
					      type: 'success'
					    });
						self.from = ''
					  })
					  .catch(error => {
					  });
				}
			  });
			  
			  // PorductApi.addWaiter({}, true)
			  //   .then(data => {
			  //    console.log(data,'chakanshuju')
			  //   })
			  //   .catch(error => {
			  //   });
				
				
				
				
			},
		}
	}
</script>




<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/technician/add.vue